import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { LockKey } from "@phosphor-icons/react";

function formatErr(d) {
  if (!d) return "Erreur";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d.msg) return d.msg;
  return String(d);
}

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      nav("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-screen flex items-center bg-[#0D2C54] px-6 py-12">
      <form
        onSubmit={onSubmit}
        data-testid="admin-login-form"
        className="bg-white max-w-md w-full mx-auto p-10 border border-[#E5E7EB]"
      >
        <div className="flex items-center gap-3 mb-8 pb-6 border-b border-[#E5E7EB]">
          <LockKey size={28} weight="duotone" className="text-[#E63946]" />
          <div>
            <h1 className="font-display font-bold text-xl text-[#0D2C54]">Espace admin</h1>
            <p className="text-xs text-[#555555]">Connexion réservée</p>
          </div>
        </div>
        <div className="space-y-5">
          <div>
            <Label className="overline text-xs text-[#0D2C54] mb-2 block">Email</Label>
            <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none h-12 border-[#E5E7EB]" required />
          </div>
          <div>
            <Label className="overline text-xs text-[#0D2C54] mb-2 block">Mot de passe</Label>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none h-12 border-[#E5E7EB]" required />
          </div>
        </div>
        <Button type="submit" data-testid="login-submit" disabled={loading} className="mt-8 w-full bg-[#E63946] hover:bg-[#D62839] text-white rounded-none h-12 font-semibold">
          {loading ? "Connexion..." : "Se connecter"}
        </Button>
      </form>
    </section>
  );
}
